const OBJECT_REPLACEMENT_CHARACTER = /\uFFFC/g;

/** Strips the U+FFFC placeholder iOS dictation can leave in a text field's value. */
export function stripObjectReplacementCharacters<T>(value: T): T {
  if (typeof value === 'string') {
    return value.replace(OBJECT_REPLACEMENT_CHARACTER, '') as T;
  }
  if (Array.isArray(value)) {
    return value.map(stripObjectReplacementCharacters) as T;
  }
  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [
        key,
        stripObjectReplacementCharacters(entry),
      ]),
    ) as T;
  }
  return value;
}
